module.exports = __webpack_public_path__ + "img/Tino's Pizza Café2.ac9ad20e.svg";